import axios from "axios";


function getAPIN8N() {
  const token = localStorage.getItem("barte-auth-token");
    const n8nApi = axios.create({
        baseURL: `${import.meta.env.VITE_N8N_API_URL}`,
        headers: {
            "Authorization": `Bearer ${token}`,
            "X-Token-Api": `${import.meta.env.VITE_N8N_TOKEN_API}`,
            "Content-Type": "application/json"
        }
    })
    n8nApi.interceptors.request.use(
        (config) => {
          const newConfig = config;
          newConfig.headers.post['Authorization'] = `Bearer ${token}`;
          newConfig.headers.post['X-Token-Api'] = `${import.meta.env.VITE_N8N_TOKEN_API}`;
          return newConfig;
        },
        (error) => Promise.reject(error)
      );
    return n8nApi;

}
export const Api_N8N = getAPIN8N();
